export default __webpack_public_path__ + "static/media/t25.282d226f.jpg";